const READY_TIMEOUT = 10000

let readyPromise = null

function ready () {
  if (readyPromise) return readyPromise

  readyPromise = new Promise(resolve => {
    const status = window.wysh_js_api_status

    if (status === 'ready') return resolve(true)
    if (status === 'not_available') return resolve(false)

    const timeout = setTimeout(() => resolve(false), READY_TIMEOUT)

    window.addEventListener(
      'wysh:ready',
      () => {
        clearTimeout(timeout)
        resolve(true)
      },
      { once: true },
    )
  })

  return readyPromise
}

async function getLists () {
  if ((await ready()) !== true) return null

  return window.WyshApi.v1.getWishlists()
}

async function getDetails (wishlistKey, options = {}) {
  if ((await ready()) !== true) return null

  return window.WyshApi.v1.getWishlist({
    wishlistKey,
    withDetails: true,
    ...options,
  })
}

async function getAllItems (wishlistKey) {
  const first = await getDetails(wishlistKey, { page: 1 })

  if (!first) return null

  const items = [...first.items]
  let pagination = first.pagination
  let page = 1

  while (pagination?.has_more === true) {
    page += 1
    const next = await getDetails(wishlistKey, { page })

    items.push(...next.items)
    pagination = next.pagination
  }

  return { ...first, items }
}

function findList (lists, variantId) {
  return (
    lists.find(list =>
      Object.values(list.items || {}).some(item =>
        item.variant_ids.map(String).includes(String(variantId)),
      ),
    ) || null
  )
}

function countItems (lists) {
  return lists.reduce((total, list) => total + list.total, 0)
}

function itemUrl (item) {
  return `/products/${item.data.handle}?variant=${item.variant_id}`
}

async function add ({ productId, variantId, wishlistKey = null }) {
  if ((await ready()) !== true) return null

  return window.WyshApi.v1.addToWishlist({
    productId,
    variantId,
    wishlistKey,
  })
}

async function remove ({ productId, variantId, wishlistKey }) {
  if ((await ready()) !== true) return null

  return window.WyshApi.v1.removeFromWishlist({
    productId,
    variantId,
    wishlistKey,
  })
}

async function createList (name) {
  if ((await ready()) !== true) return null

  return window.WyshApi.v1.createWishlist({ name })
}

async function deleteList (wishlistKey) {
  if ((await ready()) !== true) return null

  return window.WyshApi.v1.deleteWishlist({ wishlistKey })
}

function onChange (callback) {
  document.addEventListener('wysh:wishlists-changed', callback)
}

function errorMessage (error) {
  return error?.messageText || error?.message || String(error)
}

window.BAO.Wysh = {
  ready,
  getLists,
  getDetails,
  getAllItems,
  findList,
  countItems,
  itemUrl,
  add,
  remove,
  createList,
  deleteList,
  onChange,
  errorMessage,
}
